export const MAXIMUM_SAVETAX_AMOUNT = 150000;

export const MAXIMUM_SAVABLE_AMOUNT = 46800;

export const MAXIMUM_AMOUNT_LENGTH = 16;

export const RISK_PROFILE_MESSAGE_CODES = [0, 1];

export const MINIMUM_SIP_AMOUNT = 500;

const SIP_DEFAULT_AMOUNT = 5000;

const ONETIME_DEFAULT_AMOUNT = 50000;

const INVEST_SURPLUS_DEFAULT_AMOUNT = 50000;

export const INVESTMENT_FLOW_MAPPER = {
  buildwealth: "buildwealth",
  saveforgoal: "saveforgoal",
  savetax: "savetax",
  investsurplus: "investsurplus",
  diy: "diy",
  nfo: "nfo",
  gold: "gold",
};

export const EVENT_FLOWTYPE_MAPPER = {
  buildwealth: "HIGH_GROWTH_FUNDS",
  nfo: "NFO",
  savetax: "SAVE_TAX",
  saveforgoal: "INVEST_FOR_A_GOAL",
  investsurplus: "PARK_MY_SAVINGS",
  gold: "GOLD",
  diy: "DIY",
};

export const RISK_PROFILE_ENABLED_FLOWS = [
  INVESTMENT_FLOW_MAPPER.buildwealth,
  INVESTMENT_FLOW_MAPPER.investsurplus,
];

export const DEFAULT_EQUITY_DEBT_VALUES = {
  equity: 10,
  debt: 6.5,
};

export const DEFAULT_TERM_VALUES = {
  [INVESTMENT_FLOW_MAPPER.buildwealth]: 5,
  [INVESTMENT_FLOW_MAPPER.savetax]: 15,
  [INVESTMENT_FLOW_MAPPER.investsurplus]: 3,
  [INVESTMENT_FLOW_MAPPER.saveforgoal]: 15,
  [INVESTMENT_FLOW_MAPPER.gold]: 10,
};

export const INVEST_TYPE_DEFAULT_PARAMS = {
  buildwealth: {
    name: "Wealth building",
    flow: "build wealth",
    eventName: "high_growth_funds",
  },
  savetax: {
    name: "Tax saving",
    flow: "tax saving",
    eventName: "save_tax",
  },
  investsurplus: {
    name: "Wealth building",
    flow: "park my savings",
    eventName: "park_my_savings",
  },
  gold: {
    name: "Gold",
    flow: "gold",
    eventName: "gold",
  },
  saveforgoal: {
    name: "Saving for goal",
    flow: "invest for goal",
    eventName: "invest_for_a_goal",
  },
};

export const DEFAULT_RISK_TYPE = "Moderate";

export const AMOUNT_RANGE = {
  sip: {
    min: 500,
    max: 500000,
  },
  onetime: {
    min: 5000,
    max: 2000000,
  },
};

export const SIP_FLOWS = {
  buildwealth: "buildwealth",
  savetaxsip: "savetaxsip",
  saveforgoal: "saveforgoal",
  diysip: "diysip",
  sip: "sip",
  goldsip: "goldsip",
};

export const ONE_TIME_FLOWS = {
  buildwealthot: "buildwealthot",
  savetax: "savetax",
  investsurplus: "investsurplus",
  diy: "diy",
  onetime: "onetime",
  gold: "gold",
};

export const SIP_KEYS = [
  SIP_FLOWS.buildwealth,
  SIP_FLOWS.savetaxsip,
  SIP_FLOWS.saveforgoal,
  SIP_FLOWS.diysip,
  SIP_FLOWS.sip,
  SIP_FLOWS.goldsip,
];

export const ONE_TIME_KEYS = [
  ONE_TIME_FLOWS.buildwealthot,
  ONE_TIME_FLOWS.savetax,
  ONE_TIME_FLOWS.investsurplus,
  ONE_TIME_FLOWS.diy,
  ONE_TIME_FLOWS.onetime,
  ONE_TIME_FLOWS.gold,
];

export const INVEST_TYPES = {
  sip: SIP_FLOWS.sip,
  onetime: ONE_TIME_FLOWS.onetime,
};

export const INVEST_TYPE_DEFAULT_VALUES = {
  buildwealth: SIP_FLOWS.buildwealth,
  savetax: SIP_FLOWS.savetaxsip,
  investsurplus: "3Y",
  gold: SIP_FLOWS.goldsip,
  saveforgoal: SIP_FLOWS.saveforgoal,
};

const saveTaxSipMaximumAmount = () => {
  const month = new Date().getMonth() + 1;
  let duration = month > 3 ? 15 - month : 3 - month;
  if (duration === 0) {
    duration = 1;
  }
  return Math.floor(MAXIMUM_SAVETAX_AMOUNT / duration);
};

export const INVEST_TYPE_AMOUNTS = {
  [INVESTMENT_FLOW_MAPPER.buildwealth]: {
    [SIP_FLOWS.buildwealth]: SIP_DEFAULT_AMOUNT,
    [ONE_TIME_FLOWS.buildwealthot]: ONETIME_DEFAULT_AMOUNT,
  },
  [INVESTMENT_FLOW_MAPPER.savetax]: {
    [SIP_FLOWS.savetaxsip]: saveTaxSipMaximumAmount(),
    [ONE_TIME_FLOWS.savetax]: MAXIMUM_SAVETAX_AMOUNT,
  },
  [INVESTMENT_FLOW_MAPPER.investsurplus]: {
    "3Y": INVEST_SURPLUS_DEFAULT_AMOUNT,
    "1Y": INVEST_SURPLUS_DEFAULT_AMOUNT,
  },
  [INVESTMENT_FLOW_MAPPER.gold]: {
    sip: SIP_DEFAULT_AMOUNT,
    onetime: ONETIME_DEFAULT_AMOUNT,
  },
};
